import React, { useState, useEffect } from 'react';

const ClockMediaPopup = ({ onClose, onSave, media }) => {
    const [name, setName] = useState('');
    const [style, setStyle] = useState('Digital');
    const [format, setFormat] = useState('HH:mm:ss');
    const [offsetMinutes, setOffsetMinutes] = useState(0);
    const [timeZone, setTimeZone] = useState('Local');
    const [showSeconds, setShowSeconds] = useState(false);
    const [mediaId, setMediaId] = useState(null);

    useEffect(() => {
        if (media) {
            setName(media.name || '');
            setStyle(media.style || 'Digital');
            setFormat(media.format || 'HH:mm:ss');
            setOffsetMinutes(media.offsetMinutes || 0);
            setTimeZone(media.timeZone || 'Local');
            setShowSeconds(media.showSeconds || false);
            setMediaId(media.id || null);
        } else {
            setName('');
            setStyle('Digital');
            setFormat('HH:mm:ss');
            setOffsetMinutes(0);
            setTimeZone('Local');
            setShowSeconds(false);
            setMediaId(null);
        }
    }, [media]);

    const handleSave = () => {
        onSave({
            id: mediaId,
            name,
            style,
            format,
            offsetMinutes,
            timeZone,
            showSeconds,
        });
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h2>{media ? 'Edit Clock' : 'Add Clock'}</h2>

                <div className="form-group">
                    <label>Name:</label>
                    <input
                        type="text"
                        className="form-control input-style"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Clock Name"
                    />
                </div>

                <div className="form-group">
                    <label>Style:</label>
                    <select
                        className="form-control input-style"
                        value={style}
                        onChange={(e) => setStyle(e.target.value)}
                    >
                        <option value="Digital">Digital</option>
                        <option value="Analogue">Analogue</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Format:</label>
                    <input
                        type="text"
                        className="form-control input-style"
                        value={format}
                        onChange={(e) => setFormat(e.target.value)}
                        placeholder="e.g. HH:mm or hh:mm A"
                    />
                </div>

                <div className="form-group">
                    <label>Offset Minutes:</label>
                    <input
                        type="number"
                        className="form-control input-style"
                        value={offsetMinutes}
                        onChange={(e) => setOffsetMinutes(parseInt(e.target.value) || 0)}
                        placeholder="e.g. -330 for IST"
                    />
                    <small className="form-text text-muted">
                        Offset adjusts the displayed time based on your selected timezone.
                    </small>
                </div>

                <div className="form-group">
                    <label>Timezone:</label>
                    <input
                        type="text"
                        className="form-control input-style"
                        value={timeZone}
                        onChange={(e) => setTimeZone(e.target.value)}
                        placeholder="e.g. Asia/Kolkata or Local"
                    />
                </div>

                <div className="form-check mt-2 mb-3">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="showSeconds"
                        checked={showSeconds}
                        onChange={(e) => setShowSeconds(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="showSeconds">
                        Show Seconds
                    </label>
                </div>

                <div className="form-buttons">
                    <button className="btn btn-success" onClick={handleSave}>
                        {media ? 'Update' : 'Add'} Clock
                    </button>{' '}
                    <button className="btn btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ClockMediaPopup;
